import React from 'react';
import { Drawer, Skeleton } from 'antd';
import type { HomeRequestDetail } from '../../../api/homeV3Api';
import { actionLabel, formatDate, statusLabels } from '../utils/formatters';
import styles from '../HomeV3.module.css';

interface Props {
    open: boolean;
    detail?: HomeRequestDetail;
    isLoading: boolean;
    onClose: () => void;
}

export function RequestDetailDrawer({ open, detail, isLoading, onClose }: Props) {
    return (
        <Drawer title={detail ? actionLabel(detail.actionId) : 'Request details'} open={open} onClose={onClose} size={560} destroyOnHidden>
            {isLoading && !detail ? <Skeleton active paragraph={{ rows: 8 }} /> : detail ? (
                <div className={styles.stack}>
                    <div>
                        <p className={styles.eyebrow}>{detail.entityType}</p>
                        <h2>{detail.entityName}</h2>
                        <span className={styles.status}>{statusLabels[detail.normalizedStatus]}</span>
                    </div>
                    <div className={styles.drawerGrid}>
                        <div><div className={styles.metaLabel}>Request type</div><div>{detail.requestType}</div></div>
                        <div><div className={styles.metaLabel}>Submitted</div><div>{formatDate(detail.requestedAtUtc, true)}</div></div>
                        <div><div className={styles.metaLabel}>Previous value</div><div className={styles.drawerValue}>{detail.previousValue ?? 'Not available'}</div></div>
                        <div><div className={styles.metaLabel}>New value</div><div className={styles.drawerValue}>{detail.newValue ?? 'Not available'}</div></div>
                    </div>
                    {detail.requesterNote && <div><h3>Requester note</h3><p className={styles.drawerValue}>{detail.requesterNote}</p></div>}
                    {detail.stewardNote && <div><h3>Data steward note</h3><blockquote className={styles.note}>{detail.stewardNote}</blockquote>{detail.stewardName && <p className={styles.muted}>{detail.stewardName}</p>}</div>}
                    <div className={styles.drawerActions}>
                        {detail.recordDestination && <a className={styles.primaryButton} href={detail.recordDestination}>Open record</a>}
                        <button className={styles.secondaryButton} type="button" onClick={onClose}>Close</button>
                    </div>
                </div>
            ) : (
                <div className={styles.emptyState}><p>Request details could not be loaded.</p></div>
            )}
        </Drawer>
    );
}
